export const PREFILL_VARIANT_1 = 'PREFILL_VARIANT_1';

export const showPrefillVariant1 = payload => dispatch =>
  dispatch({
    type: PREFILL_VARIANT_1,
    payload,
  });
